export default __webpack_public_path__ + "static/media/database-icon.e50220ff.svg";